<template>
  <div>

    <vs-table id="rm-order-item-table" :data="raw_material_items">

      <template slot="thead">
        <vs-th class="text-xs" width="15%">SUPPLIER RM PRODUCT CODE</vs-th>
        <vs-th class="text-xs" width="15%">SUPPLIER RM PRODUCT NAME</vs-th>
        <vs-th class="text-xs" width="5%">UNIT</vs-th>
        <vs-th class="text-xs" width="15%">QUANTITY</vs-th>
        <vs-th class="text-xs" width="15%">PRICE (GBP)</vs-th>
        <vs-th width="15%" class="justify-end ml-auto mr-0 text-xs">TOTAL PRICE (GBP)</vs-th>
        <vs-th width="20%" class="text-xs">ITEM STATUS</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

          <vs-td :data="data[indextr].supplier_product_code">
            {{ data[indextr].supplier_product_code }}
          </vs-td>

          <vs-td :data="data[indextr].supplier_product_name">
            {{ data[indextr].supplier_product_name }}
          </vs-td>

          <vs-td :data="data[indextr].unit">
            {{ data[indextr].unit }}
          </vs-td>

          <vs-td :data="data[indextr].quantity">
            {{ data[indextr].quantity }}
          </vs-td>

          <vs-td :data="data[indextr].gbp_price">
            {{ (Number(data[indextr].gbp_price)).toFixed(2) }}
          </vs-td>

          <vs-td :data="data[indextr].price">
            {{data[indextr].quantity ? (Number(data[indextr].gbp_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
          </vs-td>

          <vs-td :data="data[indextr].item_status">
            <vs-dropdown vs-trigger-click class="cursor-pointer" v-if="raw_material_items.length > 1 && $can('edit-order')">
              <a class="flex items-center text-dark ml-1" href="#">
                <vs-chip v-if="data[indextr].item_status" style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
                  {{ data[indextr].item_status || 'Pending'}}
                </vs-chip>
                <i class="material-icons"> expand_more </i>
              </a>
              <vs-dropdown-menu>
                <vs-dropdown-item class="w-64"
                                  @click.prevent="onClickChangeItemStatus(data[indextr].id, status.name)"
                                  v-for="status in raw_material_order_item_statuses"
                                  v-bind:key="status.name"
                                  v-if="itemStatusManager(status.name, data[indextr].item_status) && status.name !== data[indextr].item_status && status.is_visible">
                  {{status.name}}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-chip v-else style="border-radius: 0" class="text-center text-xs" transparent :color="itemStatusColorFactory(data[indextr].item_status)">
              {{ data[indextr].item_status || 'Pending'}}
            </vs-chip>
          </vs-td>

        </vs-tr>
        <vs-tr>
          <vs-td colspan="5" style="font-weight: bolder">Total</vs-td>
          <vs-td class="" style="font-weight: bolder">{{totalCalculator()}}</vs-td>
          <vs-td></vs-td>
        </vs-tr>
      </template>

    </vs-table>
  </div>
</template>

<script>
  import {raw_material_order_item_statuses} from '@/constants/statuses'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const TradingRepository = RepositoryFactory.get('trading')

  export default {
    name: "ProductOrderTable",
    data() {
      return {
        raw_material_order_item_statuses: raw_material_order_item_statuses,
        raw_material_items : this.items
      }
    },
    props: {
      items: {
        type: Array,
        default: []
      },
      id: {
        type: Number,
        default:  ''
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    methods: {
      totalCalculator() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          if (!!m.gbp_price) {
            total = total + Number(m.gbp_price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      itemStatusManager(status, current_status) {
        // let current_id = 0
        // if (!!current_status) {
        //   current_id = this.raw_material_order_item_statuses.find((n) => n.name === current_status).id
        // }
        // const id = this.raw_material_order_item_statuses.find((n) => n.name === status).id
        // return id > current_id;
        return true;
      },
      async onClickChangeItemStatus(id, status) {
        await this.$vs.loading({
          container: '#rm-order-item-table',
          scale: 0.45
        })
        try {
          const payload = {status: status}
          await TradingRepository.statusChangeRmOrderItem(id, payload)
          await this.getProductOrdersOrder()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-item-table > .con-vs-loading')
      },
      async getProductOrdersOrder() {
        await this.$vs.loading({
          container: '#rm-order-item-table',
          scale: 0.45
        })
        const {data} = await TradingRepository.getRmOrderDetails(this.id)
        this.raw_material_items = data.data.raw_material_items
        this.$vs.loading.close('#rm-order-item-table > .con-vs-loading')
      },
      itemStatusColorFactory(status) {
        const obj = this.raw_material_order_item_statuses.find((n) => n.name === status)
        return obj ? obj.color : 'dark'
      }
    },
    watch: {
      items: function (new_value, old_value) {
        this.raw_material_items = new_value
      }
    }
  }
</script>

<style scoped>

</style>
